export default "__VITE_ASSET__CsRy0QzB__"